import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// import { AgmCoreModule } from '@agm/core';
// import { GoogleMapsAPIWrapper } from '@agm/core';
// import { MarkerManager } from '@agm/core';
import {GoogleMap, GoogleMapsModule, MapInfoWindow, MapMarker} from '@angular/google-maps';
import {UsersRoutingModule} from './users-routing.module';
import {UserHomeComponent} from './user-home/user-home.component';
// import { AdminComponent } from './admin/admin.component';
// import { ViewProjectMarkerComponent } from './view-project-marker/view-project-marker.component';
// import { ViewFloorComponent } from './view-floor/view-floor.component';
// import { ViewAllCompComponent } from './view-all-comp/view-all-comp.component';
import {SharedModule} from '../shared/shared.module';
// import { ViewConstructionTrackingComponent } from './view-construction-tracking/view-construction-tracking.component';
// import { ViewGalleryComponent } from './view-gallery/view-gallery.component';

// import { ViewFlatPrototypeComponent } from './view-flat-prototype/view-flat-prototype.component';
import {GalleryManagerComponent} from './gallery/gallery-manager/gallery-manager.component';
import {FileUploadComponent} from './gallery/file-upload/file-upload.component';
import {GalleryComponent} from './gallery/gallery.component';
// import { ViewFlatPropertiesComponent } from './view-flat-properties/view-flat-properties.component';
// import { ViewFlatComponent } from './view-flat/view-flat.component';
// import { DataForUserComponent } from './data-for-user/data-for-user.component';
import {ViewPageWithLinkComponent} from './view-page-with-link/view-page-with-link.component';
import {UserProfileComponent} from './user-profile/user-profile.component';
// import { ViewLetterFlatPrototypeComponent } from './view-letter-flat-prototype/view-letter-flat-prototype.component';
import {FullscreenComponent} from './fullscreen/fullscreen.component';
// import { ViewFloorsViewsComponent } from './view-floors-views/view-floors-views.component';
// import { BuildingComponent } from './building/building.component';
import {PinchZoomModule} from '@meddv/ngx-pinch-zoom';
// For Translate
import {TranslateModule} from '@ngx-translate/core';
// For Translate
import {DrawingFloorsComponent} from './drawing-floors/drawing-floors.component';
import {TestMenuComponent} from './test-menu/test-menu.component';
import {TestProjectComponent} from './test-project/test-project.component';
import {BuildingListComponent} from './buildings/building-list/building-list.component';
import {ViewbuildigsTestComponent} from './buildings/viewbuildigs-test/viewbuildigs-test.component';
import {FlatTestComponent} from './buildings/flat-test/flat-test.component';
import {FlatPropertiesTestComponent} from './buildings/flat-properties-test/flat-properties-test.component';
import {ViewFloorTestComponent} from './buildings/view-floor-test/view-floor-test.component';
import {ViewsFromFloorsListComponent} from './buildings/views-from-floors-list/views-from-floors-list.component';
import {ViewsFromFloorsComponent} from './buildings/views-from-floors/views-from-floors.component';
import {
    TestViewConstructionPointComponent
} from './test-view-construction-point/test-view-construction-point.component';
import {GoToProjectComponent} from './additional/go-to-project/go-to-project.component';
import {NShowGalleryComponent} from './n-show-gallery/n-show-gallery.component';
import {NShowDGalleryComponent} from './n-show-d-gallery/n-show-d-gallery.component';
import {NPageWithLinkComponent} from './n-page-with-link/n-page-with-link.component';
import {NMenuPageWithLinkComponent} from './n-menu-page-with-link/n-menu-page-with-link.component';
import {NCompanyPageComponent} from './n-company-page/n-company-page.component';
import {NMapComponent} from './n-map/n-map.component';
import {GetCompanyOnStartComponent} from './get-company-on-start/get-company-on-start.component';
import {OfferComponent} from './offers-components/offer/offer.component';
import {OfferFlatPropertiesComponent} from './offers-components/offer-flat-properties/offer-flat-properties.component';
import {OfferBuildingComponent} from './offers-components/offer-building/offer-building.component';
import {OfferBuildingMenuComponent} from './offers-components/offer-building-menu/offer-building-menu.component';
import {OfferFloorsComponent} from './offers-components/offer-floors/offer-floors.component';
import {OfferFlatComponent} from './offers-components/offer-flat/offer-flat.component';
import {AddOfferComponent} from './offers-components/add-offer/add-offer.component';
import {HowMuchRoomsComponent} from './buildings/how-much-rooms/how-much-rooms.component';
// import { BuildingFilterBlockComponent } from './buildings/building-filter-block/building-filter-block.component';
import {FlatSaleStatusComponent} from './buildings/flat-sale-status/flat-sale-status.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatSelectModule} from '@angular/material/select';
// import { MatFormFieldModule } from '@angular/material/form-field';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {FilteringComponent} from './filtering/filtering.component';
import {MatTableModule} from '@angular/material/table';
import {SearchProjectsComponent} from './search-projects/search-projects.component';
import {ModalWindowComponent} from '../design/modal-window/modal-window.component';
import {MatBadgeModule} from '@angular/material/badge';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {WindRoseComponent} from './wind-rose/wind-rose.component';
import {
    ParsingBuildingFromJsonComponent
} from './buildings/parsing-building-from-json/parsing-building-from-json.component';
import {RightMenuComponent} from './right-menu/right-menu.component';
import {FloorsChoiceComponent} from './buildings/floors-choice/floors-choice.component';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {CurrentSituationComponent} from './current-situation/current-situation.component';
import {ThreejsComponent} from './threejs/threejs.component';
import {ProjectLightComponent} from './project-light/project-light.component';
import {FlatPropetiesOntheFlyComponent} from './flat-propeties-onthe-fly/flat-propeties-onthe-fly.component';
import {NearbyOnMapComponent} from './nearby-on-map/nearby-on-map.component';
import {NearbyPlacesListComponent} from './nearby-places-list/nearby-places-list.component';
import {AboutProjectComponent} from './about-project/about-project.component';
import {FlatPrototypesFilterComponent} from './buildings/flat-prototypes-filter/flat-prototypes-filter.component';
import {
    VisualMapWithProjStatisticComponent
} from './visual-map-with-proj-statistic/visual-map-with-proj-statistic.component';
import {ProjectStatusComponent} from './project-status/project-status.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTreeModule} from '@angular/material/tree';
import {MaterialsFromClientComponent} from './materials-from-client/materials-from-client.component';
import {WholeNumPipe} from './../_core/_pipe/whole-num.pipe';
import {ClientFormComponent} from './client-form/client-form.component';
import {PriceCalculatorComponent} from './price-calculator/price-calculator.component';
import {Html2pdfComponent} from './html2pdf/html2pdf.component';
import {CalculatorOfferComponent} from './calculator-offer/calculator-offer.component';
import {AutocompliteComponent} from './autocomplite/autocomplite.component';
import {SvgLoaderComponent} from './gallery/file-upload/svg-loader-component/svg-loader.component';
import {GoogleMapComponentGPT} from './google-map-component-gpt/google-map-gpt.component';
import {VoiceNavigationComponent} from './voice-navigation/voice-navigation.component';
import {FormatSqmPipe} from '../_core/_pipe/sqm-language-change.pipe';
import {DirectionTranslatorPipe} from '../_core/_pipe/direction-language-change.pipe';
import {PriceCalculatorHousingComponent} from './price-calculator-housing/price-calculator-housing.component';
import {ShowOffersListComponent} from './show-offers-list/show-offers-list.component';
import {OfferListComponent} from './offer-list/offer-list.component';
import {AllprojmapComponent} from './allprojmap/allprojmap.component';

@NgModule({
    declarations: [UserHomeComponent,
        WholeNumPipe,
        FormatSqmPipe,
        DirectionTranslatorPipe,
        // AdminComponent,
        // ViewProjectMarkerComponent,
        // ViewFloorComponent,
        ViewPageWithLinkComponent,
        // ViewAllCompComponent,
        // ViewFlatPropertiesComponent,
        // ViewFlatComponent,
        // ViewConstructionTrackingComponent,
        // ViewFlatPrototypeComponent,
        // ViewGalleryComponent,
        GalleryComponent,
        FileUploadComponent,
        GalleryManagerComponent,
        UserProfileComponent,
        // ViewLetterFlatPrototypeComponent,
        FullscreenComponent,
        // ViewFloorsViewsComponent,
        // BuildingComponent,
        DrawingFloorsComponent,
        TestMenuComponent,
        TestProjectComponent,
        BuildingListComponent,
        ViewbuildigsTestComponent,
        FlatTestComponent,
        FlatPropertiesTestComponent,
        ViewFloorTestComponent,
        ViewsFromFloorsListComponent,
        ViewsFromFloorsComponent,
        TestViewConstructionPointComponent,
        GoToProjectComponent,
        NShowGalleryComponent,
        NShowDGalleryComponent,
        NPageWithLinkComponent,
        NMenuPageWithLinkComponent,
        NCompanyPageComponent,
        NMapComponent,
        GetCompanyOnStartComponent,
        OfferComponent,
        OfferFlatPropertiesComponent,
        OfferBuildingComponent,
        OfferBuildingMenuComponent,
        OfferFloorsComponent,
        OfferFlatComponent,
        AddOfferComponent,
        HowMuchRoomsComponent,
        // BuildingFilterBlockComponent,
        FlatSaleStatusComponent,
        ModalWindowComponent,
        FilteringComponent,
        SearchProjectsComponent,
        WindRoseComponent,
        ParsingBuildingFromJsonComponent,
        RightMenuComponent,
        FloorsChoiceComponent,
        CurrentSituationComponent,
        ThreejsComponent,
        ProjectLightComponent,
        FlatPropetiesOntheFlyComponent,
        NearbyOnMapComponent,
        NearbyPlacesListComponent,
        AboutProjectComponent,
        FlatPrototypesFilterComponent,
        VisualMapWithProjStatisticComponent,
        ProjectStatusComponent,
        MaterialsFromClientComponent,
        ClientFormComponent,
        PriceCalculatorComponent,
        Html2pdfComponent,
        CalculatorOfferComponent,
        AutocompliteComponent,
        SvgLoaderComponent,
        GoogleMapComponentGPT,
        VoiceNavigationComponent,
        PriceCalculatorHousingComponent,
        ShowOffersListComponent,
        OfferListComponent,
        AllprojmapComponent
    ],
    imports: [
        PinchZoomModule,
        NgxSliderModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        UsersRoutingModule,
        SharedModule,
        MatTabsModule,
        TranslateModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTableModule,
        MatInputModule,
        MatBadgeModule,
        MatCardModule,
        MatButtonModule,
        MatDialogModule,
        MatTooltipModule,
        GoogleMapsModule,
        MatTreeModule,
        MatIconModule,
        MatProgressBarModule,
        //   AgmCoreModule.forRoot({
        //     apiKey: 'AIzaSyDqUl59BPah8bU42xoC81qknTMJofpeask'
        //   })
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        GoogleMap,
        MapMarker,
        MapInfoWindow
    ]
})
export class UsersModule {
    NgInitDirectiveDirective
}
